module.exports = __webpack_public_path__ + "static/media/black_queen.780caba4.svg";